<template>
  <div id="user-signatures-layer">
    <div class="sign-title">印章列表</div>
    <ul class="sign-list clearfix">
      <li v-for="signatures in signaturesList" :key="signatures.id">
        <div class="sign-box">
          <el-image :src="signatures.sealImg" fit="contain" class="sign-img" :preview-src-list="
            signaturesList.map((item) => {
              return item.sealImg;
            })
          ">
          </el-image>
        </div>
        <!-- <p class="sign-tip">
					<span v-show="signatures.isGenerate == '1'">{{signatures.isGenerate == '1' ? '系统自动生成的印章' : ' '}}</span>
					<span v-show="signatures.status==0" class="spz">{{ signatures.status==0?'用章审核中，请等待':'' }}</span>
				</p> -->
        <div class="sign-name">
          <span class="sign-name-title">{{ signatures.sealName }}</span>
        </div>
      </li>
    </ul>

    <div class="mask" v-if="userScope.spaceType === 'company'" style="margin-bottom: 25px">
      <div class="sign-title">您也可以手动制作印章</div>
      <el-button type="primary" class="add-sign" @click="toMakeSeal">制作印章</el-button>
      <!-- <a href="javascript:;" class="add-sign" @click="showDraw"></a> -->
    </div>

    <draw-sign ref="draw"></draw-sign>
    <reset-sealname ref="reset" :sealId="sealId"></reset-sealname>
  </div>
</template>
<script>
import drawSign from "./draw-sign";
import resetSealname from "./reset-sealname";
import {
  getUserSealInfoApi,
  deleteSealApi,
  setDefaultSealApi,
} from "@/api/space/signatures";
import { getSpaceDetailInfo } from "@/api/home";
import { getSealList } from "@/api/common";
import { getToken } from "@/utils/auth";
export default {
  data() {
    return {
      signaturesList: [],
      sealId: "",
      clickDefault: false,
      userScope: {},
    };
  },
  created() {
    this.handleGetSpaceDetailInfo();
  },
  mounted() {
    this.getUserSealInfoHandle();
  },
  components: {
    drawSign,
    resetSealname,
  },
  methods: {
    init() {
      this.getUserSealInfoHandle();
    },
    handleGetSpaceDetailInfo() {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          this.userScope = res.data;
        }
      });
    },
    getUserSealInfoHandle() {
      getSealList({
        pageNum: 1,
        pageSize: 20,
      })
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.signaturesList = res.data.sealInfoArray;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toMakeSeal() {
      location.href = ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL) + "sealManager/seal";
    },
    deleteSealHandle(sealId) {
      this.$confirm("确定要删除吗？", "温馨提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showClose: false
      })
        .then(() => {
          deleteSealApi({
            sealId,
          })
            .then((res) => {
              if (res.code !== 200) {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success",
                });

                this.$nextTick(() => {
                  this.init();
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    setDefaultHandle(sealId) {
      if (!this.clickDefault) {
        this.clickDefault = true;
        setDefaultSealApi({
          sealId,
        })
          .then((res) => {
            if (res.code !== 200) {
              this.$message({
                showClose: true,
                message: res.message,
                type: "warning",
              });
              this.clickDefault = false;
            } else {
              this.$message({
                showClose: true,
                message: "设置成功！",
                type: "success",
              });

              this.$nextTick(() => {
                this.init();
                this.clickDefault = false;
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    showResetDialogHandle(id, sealName) {
      this.sealId = id;
      this.$refs.reset.sealForm.sealName = sealName;
      this.$refs.reset.dialogVisible = true;
    },
    showDraw() {
      this.$refs.draw.dialogVisible = true;
      this.$refs.draw.getDrawCodeHandle();
    },
  },
};
</script>
<style scoped>
.sign-title {
  border-left: 2px solid #3296fa;
  height: 21px;
  line-height: 21px;
  color: #333333;
  font-size: 16px;
  text-indent: 10px;
  margin: 18px 0 0 22px;
}

.sign-list {
  width: 888px;
  margin: 30px auto 0;
}

.sign-list li {
  width: 152px;
  float: left;
  margin-right: 32px;
  height: 230px;
  /* margin-bottom: 40px; */
}

.sign-list li:nth-of-type(5n) {
  margin-right: 0;
}

.sign-box {
  width: 152px;
  height: 152px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(240, 240, 245, 1);
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sign-img {
  display: block;
  width: 152px;
  height: 152px;
}

.sign-delete {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 152px;
  height: 31px;
  background: rgba(191, 191, 191, 1);
  border-radius: 0px 0px 10px 10px;
  text-align: center;
  line-height: 31px;
  font-size: 14px;
  color: #ffffff;
  display: none;
}

.new-icon,
.new-icon2 {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
}

.sign-tip {
  width: 152px;
  text-align: center;
  font-size: 14px;
  color: #999999;
  margin-top: 4px;
  height: 16px;
}

.sign-btns {
  width: 152px;
  /* display: flex;
													    justify-content: space-between; */
  margin-top: 10px;
  position: relative;
}

.sign-btns a {
  display: block;
  float: right;
  width: 72px;
  height: 38px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  line-height: 38px;
  background: #242b39;
  border-radius: 4px;
}

.sign-btns .set-default {
  width: 72px;
  height: 38px;
  text-align: center;
  font-size: 14px;
  color: #ffffff;
  line-height: 38px;
  background: #e85052;
  border-radius: 4px;
  float: left;
}

/* .set-default:hover{
													    background: #ed7375;
													  } */

.set-auth {
  background: #242b39;
  width: 54px;
  height: 38px;
  text-align: center;
  line-height: 38px;
  color: #ffffff;
  border-radius: 4px;
  font-size: 14px;
}

.sign-name {
  width: 152px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 16px;
}

.sign-name-title {
  color: #333333;
  line-height: 17px;
  text-align: center;
  width: 100%;
}

.sign-name-text {
  width: 70px;
  text-align: right;
  height: 16px;
  line-height: 16px;
  overflow: hidden;
  color: #3296fa;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.mask-tip {
  font-size: 14px;
  color: #3296fa;
  margin: 16px 0 0 22px;
}

.add-sign {
  width: 100px;
  margin-left: 35px;
  margin-top: 38px;
}

.edit-name {
  float: right !important;
}

.sign-box:hover {
  box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.08);
}

.sign-box:hover .sign-delete {
  display: block;
}

.sign-box:hover .new-icon {
  display: block;
}

/* .default-sign{
													    display: block;
													    width:78px;
													    height:38px;
													    background:rgba(180,56,58,1);
													    box-shadow:0px 2px 12px 1px rgba(0, 0, 0, 0.08);
													    border-radius:4px;
													    position: absolute;
													    left: 0;
													    top: 0;
													    text-align: center;
													    line-height: 38px;
													    color: #FFFFFF;
													    font-size: 14px;
													  } */

.new-icon2 {
  display: block;
}
</style>